import { Injectable } from '@angular/core';
import { Stomp } from 'stompjs/lib/stomp.js';
import * as _ from 'lodash';
import { DataService } from './data/data.service';
import { PROXIES } from 'src/app/configs';

@Injectable()
export class WebsocketService {
  stompClient: any;

  constructor(
    private dataService: DataService
  ) { }

  private subject: any;
  validTypes: any = ['push-newtimelineevent', 'push-data', 'push-newodds', 'push-newmatch', 'push-betstop', 'push-newodds'];
  public connect() {
    const ws = new WebSocket(PROXIES.Rabbit_Address);
    this.stompClient = Stomp.over(ws);
    this.connectRabbit(this);

    // return this.subject;
  }
  public disconnect() {
    if (this.stompClient) {
      this.stompClient.disconnect(() => {

      });
    }
    return this.subject;
  }
  public subscribe(tail?) {

    let route = '/exchange/betradarfeedsuof/betradarfeedsuof.client-listeners';
    const context = this;
    route = tail ? route + '.' + tail.trim() : route;
    this.stompClient.subscribe(route, (m) => {
      const reversedText = m.body.split('').join('');
      context.processMessage(reversedText);
    });

  }
  public unsubscribe(tail?) {

  }
  private connectRabbit(me) {
    this.stompClient.debug = null;
    this.stompClient.connect('testprime', 'nxbDPRzg865aphaGgTzbAc', (frame) => {

      // me.stompClient.subscribe('/exchange/risk/risk-dashboard', (m) => {
      //   me.processMessage(m.body);
      // });

    }, (message) => {
      setTimeout(() => { me.connect(); }, 5000);

    }, '/');
  }


  async processMessage(rawMsg) {
    const message = JSON.parse(rawMsg);
    if (this.validTypes.indexOf(message.type) < 0) {
    }
    switch (message.type) {
      case 'push-data':
        const messageToProcess = { data: {} };
        messageToProcess.data = { id: '', trnid: '' };
        if (message.data.hasOwnProperty('odds')) {
          messageToProcess.data = message.data.odds;
          // messageToProcess.data.id=
          this.processOddsMessage(message);
        }
        break;
    }

  }
  processOddsMessage(messageToProcess: any) {

    this.dataService.pagedData.forEach(page => {
      page.forEach(match => {
        if (match.id == messageToProcess.data.id) {

          this.updateDefaultOutCome(match, messageToProcess.data.odds.markets)
        }
      })
    });
  }

  updateDefaultOutCome(match: any, marketsWithNewOdds: Array<any>) {
    const outcomes = match.outcomes;
    let newMarket;
    matchesOdds:
    for (let index = 0; index < outcomes.length; index++) {
      const outcome = outcomes[index];
      newOdds:
      for (let index2 = 0; index2 < marketsWithNewOdds.length; index2++) {
        const market = marketsWithNewOdds[index2];
        if (market.id == outcome.market) {
          for (const marketOutcome of market.outcomes) {
            if (marketOutcome.outcome_id == outcome.id) {
              outcome.isActive = marketOutcome.is_active
              outcome.flag = marketOutcome.odds > outcome.odd ? '1' : marketOutcome.odds < outcome.odd ? '-1' : '0';
              outcome.odd = marketOutcome.odds
              continue matchesOdds;

            }
          }
          continue newOdds;

        }
      }
    }

    return newMarket;
  }
}
